/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { GetSystemSettingsByGroupResponse } from '../models/GetSystemSettingsByGroupResponse';
import type { GetSystemSettingsResponse } from '../models/GetSystemSettingsResponse';
import type { UpdateSystemSettingsValueRequest } from '../models/UpdateSystemSettingsValueRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class SettingsService {
    /**
     * Update a person in the system.
     * Update an existing person's details in the system using the UpdateSystemSettingsValueEndpoint.
     * @param id
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static updateSystemSettingsValueEndpoint(
        id: string,
        requestBody: UpdateSystemSettingsValueRequest,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/settings/value/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The provided input is invalid or missing required fields.`,
                401: `Unauthorized`,
                403: `The user is not authorized to update this person.`,
                404: `The specified setting could not be found in the system.`,
            },
        });
    }
    /**
     * Gets system settings.
     * Gets system settings with details.
     * @param id System settings parent node id.
     * @returns GetSystemSettingsByGroupResponse System settings has been found.
     * @throws ApiError
     */
    public static getSystemSettingsByGroupEndpoint(
        id: string,
    ): CancelablePromise<GetSystemSettingsByGroupResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/settings/groups/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `System settings has not been found.`,
            },
        });
    }
    /**
     * Gets system settings.
     * Gets system settings with details.
     * @returns GetSystemSettingsResponse System settings has been found.
     * @throws ApiError
     */
    public static getSystemSettingsEndpoint(): CancelablePromise<GetSystemSettingsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/settings/groups',
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `System settings has not been found.`,
            },
        });
    }
}
